import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from '@mui/material'
import { useEffect, useState } from 'react'
import {
  ChangeChannelRequest,
  ChannelEndpoint,
  QuotationExchangeChannel,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import {
  createChannelRequest,
  errorMessage,
  selectableChannels,
} from './quotationExchange.utils'

export function ExchangeChannelDialog({
  open,
  title,
  channel: initialChannel,
  onClose,
  onSave,
}: {
  open: boolean
  title: string
  channel?: QuotationExchangeChannel
  sender?: ChannelEndpoint
  recipient?: ChannelEndpoint
  onClose: () => void
  onSave: (request: ChangeChannelRequest) => Promise<void>
}) {
  const [channel, setChannel] = useState<QuotationExchangeChannel>(
    QuotationExchangeChannel.Scsn,
  )
  const [error, setError] = useState<string>()
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!open) return
    setChannel(
      initialChannel === QuotationExchangeChannel.Manual
        ? QuotationExchangeChannel.Manual
        : QuotationExchangeChannel.Scsn,
    )
    setError(undefined)
  }, [initialChannel, open])

  const save = async () => {
    try {
      setSaving(true)
      setError(undefined)
      await onSave(createChannelRequest(channel))
      onClose()
    } catch (requestError) {
      setError(errorMessage(requestError))
    } finally {
      setSaving(false)
    }
  }

  const manual = channel === QuotationExchangeChannel.Manual
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <FormControl fullWidth>
            <InputLabel>Channel</InputLabel>
            <Select
              label="Channel"
              value={channel}
              onChange={(event) =>
                setChannel(event.target.value as QuotationExchangeChannel)
              }
            >
              {selectableChannels.map((value) => (
                <MenuItem key={value} value={value}>
                  {value === QuotationExchangeChannel.Scsn ? 'SCSN' : value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Alert severity="info">
            {manual
              ? 'Manual exchange generates a document for download.'
              : 'SCSN sender and recipient endpoints are resolved automatically.'}
          </Alert>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={saving}
          loading={saving}
          onClick={save}
        >
          Save channel
        </Button>
      </DialogActions>
    </Dialog>
  )
}
